<template>
  <div>
    <div>
      <vs-row
        vs-type="flex"
        class="mb-4"
        vs-justify="center"
        vs-align="center"
        vs-w="12"
      >
        <vs-col vs-w="4" vs-justify="flex-start" vs-align="flex-start">
          <h4 style="color: #b4aa99">Pós-Venda</h4>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="flex-end"
          vs-w="8"
        >
          <vs-checkbox
            color="success"
            class="mb-2 mx-3"
            v-model="filtro.tipo"
            :disabled="blockButton"
            >Serviços Ímpares</vs-checkbox
          >
          <vs-input
            color="dark"
            class="mx-1"
            size="small"
            type="text"
            placeholder
            label="Busca"
            v-model="filtro.busca"
          ></vs-input>
          <div>
            <label style="color: black; font-size: 0.85rem" class="m-0 pl-3">Vendedor</label>
            <br />
            <el-select
              size="small"
              filterable
              clearable
              v-model="filtro.vendedor"
              class="mx-1 mt-2"
            >
              <el-option
                v-for="vendedor in vendedores"
                :value="vendedor.id"
                :label="vendedor.nome"
                :key="vendedor.id"
              ></el-option>
            </el-select>
          </div>
          <div>
            <label style="color: black; font-size: 0.85rem" class="m-0 pl-3">Segmento</label>
          <el-select
          filterable
          size="small"
          clearable
          multiple
          placeholder="Segmento"
          v-model="filtro.segmento"
          class="mx-1, mt-2"
        >
          <el-option
            v-for="segmento in segmentos"
            :value="segmento.id"
            :label="segmento.nome"
            :key="segmento.id"
          ></el-option>
        </el-select>
          </div>

          <vs-input
            size="small"
            class="mx-2"
            type="date"
            label="Data De"
            v-model="filtro.dataDe"
          ></vs-input>
          <vs-input
            size="small"
            class="mx-2"
            type="date"
            label="Data Ate"
            v-model="filtro.dataAte"
          ></vs-input>
          <el-button
            class="mx-2"
            size="small"
            plain
            :disabled="blockButton"
            type="primary"
            @click="filtrar()"
            >Filtrar</el-button
          >
        </vs-col>
      </vs-row>
    </div>
    <vs-row vs-type="flex" vs-justify="flex-start">
      <vs-col vs-w="4" class="px-2">
        <div>
          <vx-card style="background-color: #000a12">
            <vs-row vs-type="flex">
              <vs-col
                vs-w="12"
                vs-type="flex"
                vs-justify="space-between"
                vs-align="center"
              >
                <div>
                  <h5 style="color: white">
                    PARA REALIZAR: {{ osAcompanhar.length }}
                  </h5>
                </div>
              </vs-col>
            </vs-row>
          </vx-card>

          <!-- Barra de Ações do Disparo em Massa -->
          <div class="flex items-center justify-between p-2 mb-1 bg-white rounded shadow-sm" style="border: 1px solid #edf2f7; border-radius: 8px;">
            <div style="font-size: 10px; color: #718096; display: flex; align-items: center; gap: 4px;" title="Último horário do envio em massa">
              <span v-if="ultimoJob" style="font-weight: 500;">{{ formatarDataJob(ultimoJob.createdAt) }}</span>
              <span v-else style="font-weight: 500;">Sem disparos</span>
            </div>
            <div class="flex items-center" style="gap: 6px;">
              <vs-button 
                color="dark" 
                type="flat" 
                icon="settings" 
                size="small" 
                style="padding: 6px;"
                title="Configurar Régua de Disparos de Pós-Venda (Nova Aba)"
                @click="abrirReguaDisparos()"
              ></vs-button>
              <vs-button 
                color="dark" 
                type="flat" 
                icon="history" 
                size="small" 
                style="padding: 6px;"
                title="Ver Histórico Completo de Envios"
                @click="abrirModalHistorico()"
              ></vs-button>
              <vs-button 
                color="#00bba2" 
                type="filled" 
                icon="send" 
                size="small" 
                @click="abrirModalMassa()"
                :disabled="osAcompanhar.length === 0"
              >
                MENSAGEM EM MASSA
              </vs-button>
              <vs-button 
                color="#10b981" 
                type="filled" 
                icon="mark_email_read" 
                size="small" 
                @click="abrirModalMassaNps()"
                title="Disparar pesquisa NPS para as OSs de Pós-Venda"
              >
                DISPARAR NPS
              </vs-button>
              <vs-button 
                color="#0284c7" 
                type="flat" 
                icon="bar_chart" 
                size="small" 
                style="padding: 6px;"
                title="Abrir Dashboard de Resultados NPS"
                @click="irParaNpsDashboard()"
              ></vs-button>
            </div>
          </div>
          <VuePerfectScrollbar
            class="scroll-pos-venda"
            :settings="settings"
            style="background-color: #ebebeb"
          >
            <div id="osAcompanhar" class="vs-con-loading__container">
              <div v-if="!osAcompanhar.length > 0">
                <div class="con-colors">
                  <ul>
                    <span
                      class="px-3 pt-2"
                      style="
                        color: grey !important;
                        font-weight: 1000 !important;
                      "
                    >
                      <vs-icon
                        size="large"
                        icon="sentiment_dissatisfied"
                      ></vs-icon>
                    </span>
                  </ul>
                </div>
              </div>

              <div v-for="data in osAcompanhar" :key="data.id" class="mx-2">
                <vx-card :class="cardClass" class="mr-10 my-3">
                  <template slot="no-body">
                    <div class="item-details px-2">
                      <div class="my-1">
                        <div>
                          <vs-col vs-w="11">
                            <vs-col
                              vs-w="12"
                              class="mt-1"
                              vs-type="flex"
                              vs-justify="flex-start"
                              vs-align="flex-start"
                            >
                              <VisualizarCliente
                                @update="close()"
                                :id_cliente="data.id_cliente"
                                :nomeCliente="data.nomeCliente"
                              />
                            </vs-col>
                            <div
                              class="w-full"
                              @click="(iniciarModal = true), (selected = data)"
                            >
                              <vs-col
                                vs-w="12"
                                class="mt-1"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-sm">
                                  Contrato N°
                                  <a
                                    target="_blank"
                                    :href="'contrato?id=' + data.id_contrato"
                                    class="font-bold"
                                    style="color: darkblue; cursor: pointer"
                                    >{{ data.id_contrato }}</a
                                  >
                                  - Serviço N°
                                  <b>{{ data.id }} - {{ data.tipo }}</b>
                                </span>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-sm">
                                  Cliente:
                                  <b>{{ data.nomeCliente }}</b>
                                </span>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-sm">
                                  Endereco:
                                  <b>
                                    {{ data.logradouro }}, {{ data.numero }},
                                    {{ data.nomeBairro }}
                                  </b>
                                </span>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-sm">
                                  Data:
                                  <b>
                                    {{
                                      data.pos_venda == 2
                                        ? data.data_remarcacao_pos_venda
                                        : data.data_execucao
                                          | moment("DD/MM/YYYY")
                                    }}
                                  </b>
                                </span>
                              </vs-col>
                              <vs-col
                                v-if="
                                  data.obs_pos_venda != null || data.obs != null
                                "
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-sm">
                                  Obs:
                                  <b>
                                    {{
                                      data.obs_pos_venda != null
                                        ? data.obs_pos_venda
                                        : data.obs
                                    }}
                                  </b>
                                </span>
                              </vs-col>
                              <vs-col
                                v-if="data.telefone != null"
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-sm">
                                  Telefone:
                                  <b>{{ data.telefone }}</b>
                                </span>
                              </vs-col>
                            </div>
                            <!-- NPS Status & 1-Click Trigger Footer -->
                            <div class="w-full mt-2 pt-2 flex items-center justify-between" style="border-top: 1px dashed #e2e8f0; display: flex; align-items: center; justify-content: space-between;">
                              <div style="display: flex; align-items: center; gap: 4px;">
                                <span v-if="data.nps_status === 'respondido'" style="font-size: 11px; font-weight: 600; color: #059669; background: #dcfce7; padding: 2px 6px; border-radius: 4px;" :title="'Respondido em ' + (data.nps_respondido_em || '')">
                                  ✓ NPS: {{ data.nps_indicador || data.nps_satisfacao || 'Respondido' }}
                                </span>
                                <span v-else-if="data.nps_status === 'enviado'" style="font-size: 11px; font-weight: 600; color: #0284c7; background: #e0f2fe; padding: 2px 6px; border-radius: 4px;" :title="'Enviado em ' + (data.nps_enviado_em || '')">
                                  ✉ NPS Enviado
                                </span>
                                <span v-else-if="data.nps_status === 'falha'" style="font-size: 11px; font-weight: 600; color: #e11d48; background: #ffe4e6; padding: 2px 6px; border-radius: 4px;">
                                  ✕ Falha NPS
                                </span>
                                <span v-else style="font-size: 11px; font-weight: 500; color: #64748b; background: #f1f5f9; padding: 2px 6px; border-radius: 4px;">
                                  ⏱ NPS Pendente
                                </span>
                              </div>
                              <button
                                type="button"
                                class="btn-nps-trigger"
                                @click.stop="abrirModalDisparoUnitario(data)"
                                :style="{
                                  background: data.nps_status === 'respondido' ? '#f8fafc' : (data.nps_status === 'enviado' ? '#f0f9ff' : '#ecfdf5'),
                                  color: data.nps_status === 'respondido' ? '#64748b' : (data.nps_status === 'enviado' ? '#0369a1' : '#047857'),
                                  border: '1px solid ' + (data.nps_status === 'respondido' ? '#cbd5e1' : (data.nps_status === 'enviado' ? '#bae6fd' : '#a7f3d0')),
                                  borderRadius: '6px',
                                  padding: '2px 8px',
                                  fontSize: '11px',
                                  fontWeight: '600',
                                  cursor: 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '4px'
                                }"
                                :title="data.nps_status === 'respondido' ? 'Reenviar pesquisa NPS' : 'Enviar pesquisa NPS via WhatsApp para este cliente'"
                              >
                                <vs-icon icon="send" size="12px"></vs-icon>
                                <span>{{ data.nps_status === 'respondido' ? 'Reenviar' : (data.nps_status === 'enviado' ? 'Reenviar NPS' : 'Disparar NPS') }}</span>
                              </button>
                            </div>
                          </vs-col>
                          <vs-col
                            vs-w="1"
                            vs-type="flex"
                            vs-justify="flex-start"
                            vs-align="flex-start"
                          >
                            <Badge
                              v-if="data.nomeZona != null"
                              :text="data.nomeZona"
                              color="orange"
                            ></Badge>
                          </vs-col>
                        </div>
                      </div>
                    </div>
                  </template>
                </vx-card>
              </div>
            </div>
          </VuePerfectScrollbar>
        </div>
      </vs-col>
      <vs-col vs-w="4" class="px-2">
        <div>
          <vx-card style="background-color: #00bba2">
            <vs-row vs-type="flex">
              <vs-col
                vs-w="12"
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="flex-start"
              >
                <div>
                  <h5 style="color: white">
                    REALIZADOS: {{ osConcluidos.length }}
                  </h5>
                </div>
              </vs-col>
            </vs-row>
          </vx-card>
          <VuePerfectScrollbar
            class="scroll-pos-venda"
            :settings="settings"
            style="background-color: #ebebeb"
          >
            <div id="osConcluidos" class="vs-con-loading__container">
              <div v-if="!osConcluidos.length > 0">
                <div class="con-colors">
                  <ul>
                    <span
                      class="px-3 pt-2"
                      style="
                        color: grey !important;
                        font-weight: 1000 !important;
                      "
                    >
                      <vs-icon
                        size="large"
                        icon="sentiment_dissatisfied"
                      ></vs-icon>
                    </span>
                  </ul>
                </div>
              </div>

              <div v-for="data in osConcluidos" :key="data.id" class="mx-2">
                <vx-card :class="cardClass" class="mr-10 my-3">
                  <template slot="no-body">
                    <div class="item-details px-2">
                      <div class="my-1">
                        <div>
                          <vs-col vs-w="11">
                            <vs-col
                              vs-w="12"
                              vs-type="flex"
                              class="mt-1"
                              vs-justify="flex-start"
                              vs-align="flex-start"
                            >
                              <VisualizarCliente
                                @update="close()"
                                :id_cliente="data.id_cliente"
                                :nomeCliente="data.nomeCliente"
                              />
                            </vs-col>
                            <div class="w-full">
                              <vs-col
                                vs-w="12"
                                class="mt-1"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-sm">
                                  Contrato N°
                                  <a
                                    target="_blank"
                                    :href="'contrato?id=' + data.id_contrato"
                                    class="font-bold"
                                    style="color: darkblue; cursor: pointer"
                                    >{{ data.id_contrato }}</a
                                  >
                                  - Serviço N°
                                  <b>{{ data.id }} - {{ data.tipo }}</b>
                                </span>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-sm">
                                  Cliente
                                  <b>{{ data.nomeCliente }}</b>
                                </span>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-sm">
                                  Endereco:
                                  <b>
                                    {{ data.logradouro }}, {{ data.numero }},
                                    {{ data.nomeBairro }}
                                  </b>
                                </span>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-sm">
                                  Data:
                                  <b>
                                    {{
                                      data.pos_venda == 2
                                        ? data.data_remarcacao_pos_venda
                                        : data.data_execucao
                                          | moment("DD/MM/YYYY")
                                    }}
                                  </b>
                                </span>
                              </vs-col>
                              <vs-col
                                v-if="
                                  data.obs_pos_venda != null || data.obs != null
                                "
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-sm">
                                  Obs:
                                  <b>
                                    {{
                                      data.obs_pos_venda != null
                                        ? data.obs_pos_venda
                                        : data.obs
                                    }}
                                  </b>
                                </span>
                              </vs-col>
                              <vs-col
                                v-if="data.telefone != null"
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-sm">
                                  Telefone:
                                  <b>{{ data.telefone }}</b>
                                </span>
                              </vs-col>
                            </div>
                            <!-- NPS Status & 1-Click Trigger Footer -->
                            <div class="w-full mt-2 pt-2 flex items-center justify-between" style="border-top: 1px dashed #e2e8f0; display: flex; align-items: center; justify-content: space-between;">
                              <div style="display: flex; align-items: center; gap: 4px;">
                                <span v-if="data.nps_status === 'respondido'" style="font-size: 11px; font-weight: 600; color: #059669; background: #dcfce7; padding: 2px 6px; border-radius: 4px;" :title="'Respondido em ' + (data.nps_respondido_em || '')">
                                  ✓ NPS: {{ data.nps_indicador || data.nps_satisfacao || 'Respondido' }}
                                </span>
                                <span v-else-if="data.nps_status === 'enviado'" style="font-size: 11px; font-weight: 600; color: #0284c7; background: #e0f2fe; padding: 2px 6px; border-radius: 4px;" :title="'Enviado em ' + (data.nps_enviado_em || '')">
                                  ✉ NPS Enviado
                                </span>
                                <span v-else-if="data.nps_status === 'falha'" style="font-size: 11px; font-weight: 600; color: #e11d48; background: #ffe4e6; padding: 2px 6px; border-radius: 4px;">
                                  ✕ Falha NPS
                                </span>
                                <span v-else style="font-size: 11px; font-weight: 500; color: #64748b; background: #f1f5f9; padding: 2px 6px; border-radius: 4px;">
                                  Sem NPS
                                </span>
                              </div>
                              <button
                                type="button"
                                class="btn-nps-trigger"
                                @click.stop="abrirModalDisparoUnitario(data)"
                                :style="{
                                  background: data.nps_status === 'respondido' ? '#f8fafc' : (data.nps_status === 'enviado' ? '#f0f9ff' : '#ecfdf5'),
                                  color: data.nps_status === 'respondido' ? '#64748b' : (data.nps_status === 'enviado' ? '#0369a1' : '#047857'),
                                  border: '1px solid ' + (data.nps_status === 'respondido' ? '#cbd5e1' : (data.nps_status === 'enviado' ? '#bae6fd' : '#a7f3d0')),
                                  borderRadius: '6px',
                                  padding: '2px 8px',
                                  fontSize: '11px',
                                  fontWeight: '600',
                                  cursor: 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '4px'
                                }"
                                :title="data.nps_status === 'respondido' ? 'Reenviar pesquisa NPS' : 'Enviar pesquisa NPS via WhatsApp para este cliente'"
                              >
                                <vs-icon icon="send" size="12px"></vs-icon>
                                <span>{{ data.nps_status === 'respondido' ? 'Reenviar' : (data.nps_status === 'enviado' ? 'Reenviar NPS' : 'Disparar NPS') }}</span>
                              </button>
                            </div>
                          </vs-col>
                          <vs-col
                            vs-w="1"
                            vs-type="flex"
                            vs-justify="flex-start"
                            vs-align="flex-start"
                          >
                            <Badge
                              v-if="data.nomeZona != null"
                              :text="data.nomeZona"
                              color="orange"
                            ></Badge>
                          </vs-col>
                        </div>
                      </div>
                    </div>
                  </template>
                </vx-card>
              </div>
            </div>
          </VuePerfectScrollbar>
        </div>
      </vs-col>
      <vs-col vs-w="4" class="px-2">
        <div>
          <vx-card style="background-color: #f44336">
            <vs-row vs-type="flex">
              <vs-col
                vs-w="12"
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="flex-start"
              >
                <div>
                  <h5 style="color: white">
                    NÃO REALIZADOS: {{ osRemarcados.length }}
                  </h5>
                </div>
              </vs-col>
            </vs-row>
          </vx-card>
          <VuePerfectScrollbar
            class="scroll-pos-venda"
            :settings="settings"
            style="background-color: #ebebeb"
          >
            <div id="osRemarcados" class="vs-con-loading__container">
              <div v-if="!osRemarcados.length > 0">
                <div class="con-colors">
                  <ul>
                    <span
                      class="px-3 pt-2"
                      style="
                        color: grey !important;
                        font-weight: 1000 !important;
                      "
                    >
                      <vs-icon
                        size="large"
                        icon="sentiment_dissatisfied"
                      ></vs-icon>
                    </span>
                  </ul>
                </div>
              </div>

              <div v-for="data in osRemarcados" :key="data.id" class="mx-2">
                <vx-card :class="cardClass" class="mr-10 my-3">
                  <template slot="no-body">
                    <div class="item-details px-2">
                      <div class="my-1">
                        <div>
                          <vs-col vs-w="11">
                            <vs-col
                              vs-w="12"
                              class="mt-1"
                              vs-type="flex"
                              vs-justify="flex-start"
                              vs-align="flex-start"
                            >
                              <VisualizarCliente
                                @update="close()"
                                :id_cliente="data.id_cliente"
                                :nomeCliente="data.nomeCliente"
                              />
                            </vs-col>
                            <div class="w-full">
                              <vs-col
                                vs-w="12"
                                class="mt-1"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-sm">
                                  Contrato N°
                                  <a
                                    target="_blank"
                                    :href="'contrato?id=' + data.id_contrato"
                                    class="font-bold"
                                    style="color: darkblue; cursor: pointer"
                                    >{{ data.id_contrato }}</a
                                  >
                                  - Serviço N°
                                  <b>{{ data.id }} - {{ data.tipo }}</b>
                                </span>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-sm">
                                  Cliente
                                  <b>{{ data.nomeCliente }}</b>
                                </span>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-sm">
                                  Endereco:
                                  <b>
                                    {{ data.logradouro }}, {{ data.numero }},
                                    {{ data.nomeBairro }}
                                  </b>
                                </span>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-sm">
                                  Data:
                                  <b>
                                    {{
                                      data.data_remarcacao_pos_venda
                                        | moment("DD/MM/YYYY")
                                    }}
                                  </b>
                                </span>
                              </vs-col>
                              <vs-col
                                v-if="
                                  data.obs_pos_venda != null || data.obs != null
                                "
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-sm">
                                  Obs:
                                  <b>
                                    {{
                                      data.obs_pos_venda != null
                                        ? data.obs_pos_venda
                                        : data.obs
                                    }}
                                  </b>
                                </span>
                              </vs-col>
                              <vs-col
                                v-if="data.telefone != null"
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-sm">
                                  Telefone:
                                  <b>{{ data.telefone }}</b>
                                </span>
                              </vs-col>
                            </div>
                            <!-- NPS Status & 1-Click Trigger Footer -->
                            <div class="w-full mt-2 pt-2 flex items-center justify-between" style="border-top: 1px dashed #e2e8f0; display: flex; align-items: center; justify-content: space-between;">
                              <div style="display: flex; align-items: center; gap: 4px;">
                                <span v-if="data.nps_status === 'respondido'" style="font-size: 11px; font-weight: 600; color: #059669; background: #dcfce7; padding: 2px 6px; border-radius: 4px;" :title="'Respondido em ' + (data.nps_respondido_em || '')">
                                  ✓ NPS: {{ data.nps_indicador || data.nps_satisfacao || 'Respondido' }}
                                </span>
                                <span v-else-if="data.nps_status === 'enviado'" style="font-size: 11px; font-weight: 600; color: #0284c7; background: #e0f2fe; padding: 2px 6px; border-radius: 4px;" :title="'Enviado em ' + (data.nps_enviado_em || '')">
                                  ✉ NPS Enviado
                                </span>
                                <span v-else-if="data.nps_status === 'falha'" style="font-size: 11px; font-weight: 600; color: #e11d48; background: #ffe4e6; padding: 2px 6px; border-radius: 4px;">
                                  ✕ Falha NPS
                                </span>
                                <span v-else style="font-size: 11px; font-weight: 500; color: #64748b; background: #f1f5f9; padding: 2px 6px; border-radius: 4px;">
                                  ⏱ NPS Pendente
                                </span>
                              </div>
                              <button
                                type="button"
                                class="btn-nps-trigger"
                                @click.stop="abrirModalDisparoUnitario(data)"
                                :style="{
                                  background: data.nps_status === 'respondido' ? '#f8fafc' : (data.nps_status === 'enviado' ? '#f0f9ff' : '#ecfdf5'),
                                  color: data.nps_status === 'respondido' ? '#64748b' : (data.nps_status === 'enviado' ? '#0369a1' : '#047857'),
                                  border: '1px solid ' + (data.nps_status === 'respondido' ? '#cbd5e1' : (data.nps_status === 'enviado' ? '#bae6fd' : '#a7f3d0')),
                                  borderRadius: '6px',
                                  padding: '2px 8px',
                                  fontSize: '11px',
                                  fontWeight: '600',
                                  cursor: 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '4px'
                                }"
                                :title="data.nps_status === 'respondido' ? 'Reenviar pesquisa NPS' : 'Enviar pesquisa NPS via WhatsApp para este cliente'"
                              >
                                <vs-icon icon="send" size="12px"></vs-icon>
                                <span>{{ data.nps_status === 'respondido' ? 'Reenviar' : (data.nps_status === 'enviado' ? 'Reenviar NPS' : 'Disparar NPS') }}</span>
                              </button>
                            </div>
                          </vs-col>
                          <vs-col
                            vs-w="1"
                            vs-type="flex"
                            vs-justify="flex-start"
                            vs-align="flex-start"
                          >
                            <Badge
                              v-if="data.nomeZona != null"
                              :text="data.nomeZona"
                              color="orange"
                            ></Badge>
                          </vs-col>
                        </div>
                      </div>
                    </div>
                  </template>
                </vx-card>
              </div>
            </div>
          </VuePerfectScrollbar>
        </div>
      </vs-col>
    </vs-row>
    <vs-popup
      class
      :title="'ACOMPANHAMENTO AVALIATIVO: ' + selected.nomeCliente"
      :active.sync="iniciarModal"
    >
      <vs-row
        vs-type="flex"
        vs-align="center"
        class="vs-con-loading__container"
        id="loading"
      >
        <vs-col
          vs-w="4"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          class="p-5"
        >
          <ConcluirPosVenda
            @update="close()"
            :item="selected"
          ></ConcluirPosVenda>
        </vs-col>
        <vs-col
          vs-w="4"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          class="p-5"
        >
          <ReagendarPosVenda
            @update="close()"
            :item="selected"
          ></ReagendarPosVenda>
        </vs-col>
        <vs-col
          vs-w="4"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          class="p-5"
        >
          <modalContactar
            @update="close()"
            @confirmacao-atualizada="atualizarContatoConfirmacaoLocal"
            @fechar-pai="iniciarModal = false"
            :item="selected"
            tipo="pos_venda"
          ></modalContactar>
        </vs-col>
        <vs-col
          vs-w="12"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          class="pt-2 pb-4"
          style="border-top: 1px solid #edf2f7; margin-top: 8px;"
        >
          <vs-button
            color="#10b981"
            type="gradient"
            icon="send"
            size="small"
            @click="abrirModalDisparoUnitario(selected)"
          >
            Disparar Pesquisa NPS via WhatsApp (OS #{{ selected.id }})
          </vs-button>
        </vs-col>
      </vs-row>
    </vs-popup>

    <modal-disparo-em-massa
      :active.sync="modalMassaActive"
      :osList="osAcompanhar"
      tipo="pos_venda"
      @success="fecharModalMassaComSucesso"
    />

    <modal-disparo-em-massa-nps
      :active.sync="modalMassaNpsActive"
      @concluido="recarregarAposNps"
    />

    <!-- Modal Disparo Unitário NPS -->
    <vs-popup
      title="Disparar Pesquisa de Satisfação NPS"
      :active.sync="modalDisparoUnitarioAtivo"
      class="modal-disparo-unitario-nps"
    >
      <div v-if="osDisparoNps" class="p-3" style="min-width: 380px;">
        <div class="mb-4" style="background: #f8fafc; border-radius: 8px; padding: 12px; border: 1px solid #e2e8f0;">
          <div style="font-size: 13px; font-weight: 700; color: #0f172a; margin-bottom: 4px;">
            OS #{{ osDisparoNps.id }} - {{ osDisparoNps.nomeCliente }}
          </div>
          <div style="font-size: 12px; color: #64748b; margin-bottom: 2px;">
            <strong>Serviço:</strong> {{ osDisparoNps.tipo || 'Atendimento' }}
          </div>
          <div style="font-size: 12px; color: #64748b; margin-bottom: 2px;">
            <strong>Data Execução:</strong> {{ osDisparoNps.data_execucao | moment("DD/MM/YYYY") }}
          </div>
          <div v-if="osDisparoNps.nps_status" style="font-size: 12px; color: #0284c7; margin-top: 6px;">
            <strong>Status Atual:</strong> {{ osDisparoNps.nps_status === 'respondido' ? 'Já respondido (' + (osDisparoNps.nps_indicador || '') + ')' : (osDisparoNps.nps_status === 'enviado' ? 'Enviado anteriormente (' + (osDisparoNps.nps_enviado_em || '') + ')' : 'Pendente') }}
          </div>
        </div>

        <div class="mb-4">
          <label style="font-size: 12px; font-weight: 600; color: #334155; display: block; margin-bottom: 4px;">
            Número do WhatsApp do Cliente:
          </label>
          <vs-input
            icon-pack="feather"
            icon="icon-phone"
            placeholder="Ex: 92999998888"
            v-model="telefoneDisparoNps"
            class="w-full"
          />
          <span style="font-size: 11px; color: #64748b; margin-top: 4px; display: block;">
            O cliente receberá uma mensagem via WhatsApp com o link seguro do formulário web da OS #{{ osDisparoNps.id }}.
          </span>
        </div>

        <div class="flex items-center justify-end gap-2" style="display: flex; justify-content: flex-end; gap: 8px;">
          <vs-button color="danger" type="flat" @click="modalDisparoUnitarioAtivo = false">Cancelar</vs-button>
          <vs-button
            color="#10b981"
            type="filled"
            icon="send"
            :disabled="enviandoNpsUnitario || !telefoneDisparoNps"
            @click="confirmarDisparoUnitario"
          >
            {{ enviandoNpsUnitario ? 'Enviando...' : 'Confirmar e Enviar' }}
          </vs-button>
        </div>
      </div>
    </vs-popup>

  </div>
</template>
<script>
import components from "@/components/default/exports.js";
import ConcluirPosVenda from "./components/concluirPosVenda";
import ReagendarPosVenda from "./components/reagendarPosVenda";
import VisualizarCliente from "./../cliente/visualizar.vue";
import modalContactar from "./../confirmacao/components/contactarModal";
import ModalDisparoEmMassa from "./../confirmacao/components/modalDisparoEmMassa.vue";
import ModalDisparoEmMassaNps from "./../nps/components/modalDisparoEmMassaNps.vue";

export default {
  components: {
    ConcluirPosVenda,
    ReagendarPosVenda,
    VisualizarCliente,
    modalContactar,
    ...components,
    ModalDisparoEmMassa,
    "modal-disparo-em-massa": ModalDisparoEmMassa,
    ModalDisparoEmMassaNps,
    "modal-disparo-em-massa-nps": ModalDisparoEmMassaNps,
  },
  data() {
    return {
      filtro: {
        dataHoje: this.$formartData.dataFiltro(),
        dataDe: this.$formartData.dataFiltro(),
        dataAte: this.$formartData.dataFiltro(),
        segmento: null,
        tipo: null,
      },
      vendedores: [],
      segmentos: [],
      turnos: [
        { id: null, nome: "Nenhum" },
        { id: 1, nome: "Manha" },
        { id: 2, nome: "Almoco" },
        { id: 3, nome: "Tarde" },
        { id: 4, nome: "Noite" },
        { id: 5, nome: "Madrugada" },
      ],

      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.8,
      },
      cardClass: "os-card overflow-hidden",
      selected: [],
      iniciarModal: false,
      modalMassaActive: false,
      modalMassaNpsActive: false,
      modalDisparoUnitarioAtivo: false,
      osDisparoNps: null,
      telefoneDisparoNps: "",
      enviandoNpsUnitario: false,
      ultimoJob: null,
      osAcompanhar: [],
      osConcluidos: [],
      osRemarcados: [],
      blockButton: false,
      atividades: ["4", "5", "6"],
    };
  },
  async mounted() {
    this.$vs.loading();
    
    await Promise.all([
      this.getOsPosVendaAcompanhar(),
      this.getOsPosVendaConcluido(),
      this.getOsPosVendaRemarcado(),
      this.getVendedores(),
      this.getSegmentos(),
      this.getUltimoJobStatus()
    ]);
    
    this.$vs.loading.close();

    // Auto-open modal AFTER data loads so osList is populated
    const queryTab = this.$route.query.disparo_aba || new URLSearchParams(window.location.search).get('disparo_aba');
    if (queryTab) {
      console.log("[posVenda] Query 'disparo_aba' detectada. Abrindo modal automaticamente com aba:", queryTab);
      await this.$nextTick();
      if (queryTab === 'historico') {
        this.abrirModalHistorico();
      } else {
        this.abrirModalMassa();
      }
    }
  },
  methods: {
    async getUltimoJobStatus() {
      try {
        const res = await this.$http.get('whatsapp/enviar-massa/ultimo-job/pos_venda');
        const responseData = res.data || res;
        this.ultimoJob = responseData.data !== undefined ? responseData.data : responseData;
      } catch (err) {
        console.error("Erro ao buscar histórico do disparo em massa:", err);
      }
    },
    formatarDataJob(dataIso) {
      if (!dataIso) return '';
      const data = new Date(dataIso);
      return data.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
    },
    fecharModalMassaComSucesso() {
      console.log("[posVenda] Fechando modal de disparo em massa com sucesso.");
      this.modalMassaActive = false;
      this.getUltimoJobStatus();
      this.getOsPosVendaAcompanhar();
    },
    abrirModalMassa() {
      const url = new URL(window.location);
      url.searchParams.set('disparo_aba', 'novo');
      window.history.replaceState({}, '', url);
      if (this.$route && this.$route.query) {
        this.$route.query.disparo_aba = 'novo';
      }
      this.modalMassaActive = true;
    },
    abrirReguaDisparos() {
      const routeData = this.$router.resolve({
        path: '/regua-disparos',
        query: { tab: 'pos_venda' }
      });
      window.open(routeData.href, '_blank');
    },
    abrirModalHistorico() {
      const url = new URL(window.location);
      url.searchParams.set('disparo_aba', 'historico');
      window.history.replaceState({}, '', url);
      if (this.$route && this.$route.query) {
        this.$route.query.disparo_aba = 'historico';
      }
      this.modalMassaActive = true;
    },
    async getOsPosVendaAcompanhar() {
      await this.$vs.loading({ container: "#osAcompanhar", scale: 0.6 });
      try {
        this.osAcompanhar = await this.$http.post(
          `getOsPosVendaAcompanhar`,
          this.filtro
        );
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      }
      await this.$vs.loading.close("#osAcompanhar > .con-vs-loading");
    },
    async getOsPosVendaConcluido() {
      await this.$vs.loading({ container: "#osConcluidos", scale: 0.6 });
      try {
        this.osConcluidos = await this.$http.post(
          `getOsPosVendaConcluido`,
          this.filtro
        );
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      }
      await this.$vs.loading.close("#osConcluidos > .con-vs-loading");
    },
    async getOsPosVendaRemarcado() {
      await this.$vs.loading({ container: "#osRemarcados", scale: 0.6 });
      try {
        this.osRemarcados = await this.$http.post(
          `getOsPosVendaRemarcado`,
          this.filtro
        );
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      }
      await this.$vs.loading.close("#osRemarcados > .con-vs-loading");
    },
    async getVendedores() {
      try {
        this.vendedores = await this.$http.post(
          `colaboradorAtividade`,
          this.atividades
        );
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      }
    },
    async getSegmentos() {
      try {
        this.segmentos = await this.$http.get(`segmento`);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      }
    },
   
    async filtrar() {
      this.blockButton = true;
      await this.getOsPosVendaAcompanhar();
      await this.getOsPosVendaConcluido();
      await this.getOsPosVendaRemarcado();
      this.blockButton = false;
    },
    async close() {
      this.iniciarModal = await false;
      await this.getOsPosVendaAcompanhar();
      await this.getOsPosVendaConcluido();
      await this.getOsPosVendaRemarcado();
    },
    atualizarContatoConfirmacaoNaLista(
      lista,
      idContrato,
      idContatoConfirmacao,
      nomeContatoConfirmacao,
      contatoConfirmacao
    ) {
      if (!Array.isArray(lista)) {
        return;
      }
      lista.forEach((item) => {
        if (item.id_contrato == idContrato) {
          item.id_contato_confirmacao = idContatoConfirmacao;
          if (nomeContatoConfirmacao !== undefined) {
            item.nomeContatoConfirmacao = nomeContatoConfirmacao;
          }
          if (contatoConfirmacao !== undefined) {
            item.contatoConfirmacao = contatoConfirmacao;
          }
        }
      });
    },
    atualizarContatoConfirmacaoLocal({ idContrato, idContatoConfirmacao, nomeContatoConfirmacao, contatoConfirmacao }) {
      this.atualizarContatoConfirmacaoNaLista(
        this.osAcompanhar,
        idContrato,
        idContatoConfirmacao,
        nomeContatoConfirmacao,
        contatoConfirmacao
      );
      this.atualizarContatoConfirmacaoNaLista(
        this.osConcluidos,
        idContrato,
        idContatoConfirmacao,
        nomeContatoConfirmacao,
        contatoConfirmacao
      );
      this.atualizarContatoConfirmacaoNaLista(
        this.osRemarcados,
        idContrato,
        idContatoConfirmacao,
        nomeContatoConfirmacao,
        contatoConfirmacao
      );

      if (this.selected && this.selected.id_contrato == idContrato) {
        this.selected.id_contato_confirmacao = idContatoConfirmacao;
        if (nomeContatoConfirmacao !== undefined) {
          this.selected.nomeContatoConfirmacao = nomeContatoConfirmacao;
        }
        if (contatoConfirmacao !== undefined) {
          this.selected.contatoConfirmacao = contatoConfirmacao;
        }
      }
    },
    abrirModalDisparoUnitario(os) {
      if (!os) return;
      this.osDisparoNps = os;
      this.telefoneDisparoNps = os.contatoConfirmacao || os.telefone || "";
      this.modalDisparoUnitarioAtivo = true;
    },
    async confirmarDisparoUnitario() {
      if (!this.osDisparoNps || !this.telefoneDisparoNps) return;
      this.enviandoNpsUnitario = true;
      this.$vs.loading({ container: ".modal-disparo-unitario-nps", scale: 0.6 });
      try {
        const res = await this.$http.post("nps/disparar-unitario", {
          id_os: this.osDisparoNps.id,
          telefone: this.telefoneDisparoNps
        });
        if (res && res.data && res.data.success) {
          this.$vs.notify({
            color: "success",
            title: "NPS Enviado!",
            text: res.data.message || "Pesquisa enviada com sucesso ao cliente."
          });
          this.$set(this.osDisparoNps, "nps_status", "enviado");
          this.$set(this.osDisparoNps, "nps_enviado_em", "Agora");
          this.modalDisparoUnitarioAtivo = false;
        } else {
          var msg = (res && res.data && res.data.message) ? res.data.message : "Não foi possível disparar o NPS.";
          this.$vs.notify({
            color: "danger",
            title: "Falha no Envio",
            text: msg
          });
        }
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        this.enviandoNpsUnitario = false;
        this.$vs.loading.close(".modal-disparo-unitario-nps > .con-vs-loading");
      }
    },
    irParaNpsDashboard() {
      this.$router.push("/nps");
    },
    abrirModalMassaNps() {
      this.modalMassaNpsActive = true;
    },
    recarregarAposNps() {
      this.getOsPosVendaAcompanhar();
      this.getOsPosVendaConcluido();
      this.getOsPosVendaRemarcado();
    },
  },
};
</script>
<style scoped lang="scss">
.list-item {
  background-color: #fff;
  transition: background 0.1s ease-in-out;
  border-radius: 3px;
  font-size: 16px;
}
.list-item:hover {
  background: #dcdcdc;
}
.active-list-item {
  background-color: #000a12;
  transition: background 0.1s ease-in-out;
  border-radius: 3px;
  font-size: 16px;
  color: #ffca00;
}
.os-card {
  transition-duration: 50ms;
  &:hover {
    transition-duration: 150ms;
    transform: translateY(-3px);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);
    background-color: #eeeeee;
    color: black;
    cursor: pointer;

    .grid-view-img {
      opacity: 0.9;
    }
  }
}
.scroll-pos-venda {
  height: 70vh !important;
}
</style>
